import { Dialog, DialogContent, DialogTitle } from "@uicomponents/ui/dialog";

import logoImage from "@landingClient/assets/textlessLogo.png";
import { AuthModalParams } from "@landingClient/store/modalSlice";
import { Authenticator } from "./auth/Authenticator";
import { Box } from "@mui/material";

interface AuthDialogProps {
  isOpen: boolean;
  onClose: () => void;
  dialogParams: AuthModalParams | null;
}

export function AuthDialog({ isOpen, onClose, dialogParams }: AuthDialogProps) {
  function authDialogOnClose() {
    onClose();
  }

  return (
    <Dialog open={isOpen} onClose={authDialogOnClose}>
      <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden gap-0">
        <Box
          bgcolor={"hsl(222 47% 11% / 90%)"}
          className="bg-primary p-6 text-primary-foreground flex flex-col items-center justify-center text-center"
        >
          <div className="w-24 h-24 bg-white/100 rounded-4xl flex items-center justify-center backdrop-blur-sm">
            <img src={logoImage} alt="Logo" className="rounded-4xl" />
          </div>
          <DialogTitle className="text-2xl font-heading font-bold mb-1">
            Welcome to SmartCMA
          </DialogTitle>
        </Box>

        <div className="p-6">
          <Authenticator
            defaultTab={dialogParams?.defaultTab}
            defaultUsername={dialogParams?.defaultUsername}
            defaultPassword={dialogParams?.defaultPassword}
          />
          <div className="mt-6 text-center text-xs text-muted-foreground">
            By continuing, you agree to our Terms of Service and Privacy Policy.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
